import React from 'react'
import ReactDOM from 'react-dom';

const BidHistoryTableHeader = (props) => {
  const { handleSort, handleSortDirection, sortOption, sortDirection } = props

  return (
    <div className="card-list-header">
      {/*TODO: replace this to real data*/}
      <div className="flex-row">
        <div className="col-md-7">
        </div>
        <div className="col-md-5">
          <div className="row">
            <div className="col-md-8">
              <select value={sortOption} className="form-control white-back" onChange={handleSort}>
                <option value="end_time">Auction End Time</option>
              </select>
            </div>
            <div className="col-md-4">
              <select value={sortDirection} className="form-control white-back" onChange={handleSortDirection}>
                <option value="desc">&#x25bc;</option>
                <option value="asc">&#x25B2;</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
};

export default BidHistoryTableHeader;
